/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import OptionIcon from 'assets/icons/options-icon'
import capitalize from 'utils/capitalize'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'
import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper } from '../style'
import { renderSitesStatusIcon } from '../../SitesManagement/sitesTable'
import { SortingArrowWrapper } from 'components/SortingArrow/style'

export const makeEcosystemTabRow = (ecosystemTableData) => {
  if (!Array.isArray(ecosystemTableData)) {
    return []
  }

  const formatBool = (val) => {
    if (val === true || val === 'Yes') return 'Yes'
    if (val === false || val === 'No') return 'No'
    return '-'
  }

  const formatNumber = (val) => {
    if (val === null || val === undefined || val === '') return '-'
    if (typeof val === 'number') {
      return Number.isInteger(val) ? val.toString() : val.toFixed(2)
    }
    return val
  }

  return ecosystemTableData.map((item) => {
    const siteStatus = item.kbaStatus
    return {
      siteCode: item.siteCode || item.SiteId || item.siteId || '-',
      region: Array.isArray(item.region) ? item.region.join(', ') : (item.region || '-'),
      country: Array.isArray(item.country) ? item.country.join(', ') : (item.country || item.countryLabel || '-'),
      siteName: item.siteName || item.siteNameEng || '-',
      year: item.year != null ? item.year : '-',
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification || '-',
      ecosystemName: item.ecosystemName || item.name || '-',
      qualifyingEcosystem: formatBool(item.qualifyingEcosystem),
      ecosystemRedListCat: item.ecosystemRedListCat || item.RedListCategory || '-',
      globalExtent: formatNumber(item.globalExtent != null ? item.globalExtent : item.ecosystemGlobalExtent),
      extentAtSiteBest: formatNumber(item.extentAtSiteBest != null ? item.extentAtSiteBest : item.ecosystemGlobalExtentBest),
      assessmentDate: item.assessmentDate != null ? item.assessmentDate : (item.yearOfSiteData != null ? item.yearOfSiteData : '-'),
      percentInSite: formatNumber(item.percentInSite),
      ecosystems_criteria: Array.isArray(item.ecosystems_criteria)
        ? item.ecosystems_criteria.join(', ')
        : (item.ecosystems_criteria || item.ecosystemKbaTriggered || '-'),
      options: (
        <ReportsFactsheetWrapper>
          <ReportsFactsheetIconWrapper>
            <ExternalLinkIcon />
          </ReportsFactsheetIconWrapper>
          <ReportsFactsheetIconWrapper>
            <OptionIcon />
          </ReportsFactsheetIconWrapper>
        </ReportsFactsheetWrapper>
      )
    }
  })
}

export const makeEcosystemTabColumns = (sorting, setSorting, rows = []) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteId = () => {
    sortFunction('siteCode')
  }

  const sortByRegion = () => {
    sortFunction('region')
  }

  const sortByCountry = () => {
    sortFunction('country')
  }

  const sortBySiteName = () => {
    sortFunction('siteName')
  }

  const sortByYear = () => {
    sortFunction('year')
  }

  const sortByKbaStatus = () => {
    sortFunction('kbaStatus')
  }

  const sortByKbaClassification = () => {
    sortFunction('kbaClassification')
  }

  const sortByEcosystemName = () => {
    sortFunction('ecosystemName')
  }

  const sortByQualifyingEcosystem = () => {
    sortFunction('qualifyingEcosystem')
  }

  const sortByEcosystemRedListCat = () => {
    sortFunction('ecosystemRedListCat')
  }

  const sortByGlobalExtent = () => {
    sortFunction('globalExtent')
  }

  const sortByExtentAtSiteBest = () => {
    sortFunction('extentAtSiteBest')
  }

  const sortByAssessmentDate = () => {
    sortFunction('assessmentDate')
  }

  const sortByPercentInSite = () => {
    sortFunction('percentInSite')
  }

  const sortByEcosystemKbaTriggered = () => {
    sortFunction('ecosystems_criteria')
  }

  return [
    {
      id: 'siteCode',
      width: getStickyTableColumnsLength('siteCode', rows, 130),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteId}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      width: getStickyTableColumnsLength('region', rows, 150),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='region' />
          <SortingArrow
            onChange={sortByRegion}
            checked={sorting.sortBy === 'region' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'region',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      width: getStickyTableColumnsLength('country', rows, 150, true),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='country' />
          <SortingArrow
            onChange={sortByCountry}
            checked={sorting.sortBy === 'country' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'siteName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      width: getStickyTableColumnsLength('year', rows, 140),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfAssessment' />
          <SortingArrow
            onChange={sortByYear}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      width: getStickyTableColumnsLength('SiteStatusId', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortByKbaStatus}
            checked={sorting.sortBy === 'kbaStatus' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaClassification' />
          <SortingArrow
            onChange={sortByKbaClassification}
            checked={sorting.sortBy === 'kbaClassification' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'kbaClassification',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'ecosystemName',
      width: getStickyTableColumnsLength('ecosystemName', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='ecosystemName' />
          <SortingArrow
            onChange={sortByEcosystemName}
            checked={sorting.sortBy === 'ecosystemName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'ecosystemName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'qualifyingEcosystem',
      width: getStickyTableColumnsLength('qualifyingEcosystem', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='qualifyingEcosystem' />
          <SortingArrow
            onChange={sortByQualifyingEcosystem}
            checked={sorting.sortBy === 'qualifyingEcosystem' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'qualifyingEcosystem',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'ecosystemRedListCat',
      width: getStickyTableColumnsLength('ecosystemRedListCat', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='ecosystemRedListCat' />
          <SortingArrow
            onChange={sortByEcosystemRedListCat}
            checked={sorting.sortBy === 'ecosystemRedListCat' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'ecosystemRedListCat',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'globalExtent',
      width: getStickyTableColumnsLength('globalExtent', rows, 150),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='globalExtent' />
          <SortingArrow
            onChange={sortByGlobalExtent}
            checked={sorting.sortBy === 'globalExtent' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'globalExtent',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'extentAtSiteBest',
      width: getStickyTableColumnsLength('extentAtSiteBest', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='extentAtSiteBest' />
          <SortingArrow
            onChange={sortByExtentAtSiteBest}
            checked={sorting.sortBy === 'extentAtSiteBest' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'extentAtSiteBest',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'assessmentDate',
      width: getStickyTableColumnsLength('assessmentDate', rows, 150),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfSiteData' />
          <SortingArrow
            onChange={sortByAssessmentDate}
            checked={sorting.sortBy === 'assessmentDate' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'assessmentDate',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'percentInSite',
      width: getStickyTableColumnsLength('percentInSite', rows, 130),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='percentInSite' />
          <SortingArrow
            onChange={sortByPercentInSite}
            checked={sorting.sortBy === 'percentInSite' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'percentInSite',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'ecosystems_criteria',
      width: getStickyTableColumnsLength('ecosystems_criteria', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaCriterias' />
          <SortingArrow
            onChange={sortByEcosystemKbaTriggered}
            checked={sorting.sortBy === 'ecosystems_criteria' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'ecosystems_criteria',
      cell: ({ getValue }) => getValue()
    }
  ]
}
